// extracted by mini-css-extract-plugin
export default {"container":"bank_details_modal_container__wzoJc","buttonGroup":"bank_details_modal_buttonGroup__Yc3a-"};